import { createContext } from "react";
import { DisplayCurrency, PrecisionsData, PrecisionType } from "@shared/types";

export const PrecisionsDataContext = createContext<
  | {
      data: PrecisionsData | undefined;
      getPrecision: (
        precisionType: PrecisionType,
        symbol?: string,
        exchange?: string
      ) => number;
      getMinimumPrecision: (
        precisionType: PrecisionType,
        symbol: string,
        exchanges: string[]
      ) => number;
      isLoading: boolean;
      getDisplayCurrencyAmountPrecision: (
        argsDisplayCurrency?: DisplayCurrency
      ) => number;
      applyPrecision: (
        value: number,
        precisionType: PrecisionType,
        symbol?: string,
        exchange?: string
      ) => number;
    }
  | undefined
>(undefined);
